module.exports = __webpack_public_path__ + "img/cart.497f8c84.svg";